import React from 'react';
import { useTheme } from '../hooks/useTheme';

/**
 * Shown when diagram publish fails due to GitLab sync conflict.
 * - "Use platform version": clears conflict, re-publishes (overwrites GitLab)
 * - "Accept GitLab version": pulls GitLab DSL into meta, opens code panel
 *   NOTE: visual modeler is NOT updated automatically — user must click
 *   "Применить" in the code panel to apply the GitLab version visually.
 */
const DiagramConflictModal = ({ isOpen, onClose, onAcceptPlatform, onAcceptGitlab, isResolving }) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  const overlay = {
    position: 'fixed', inset: 0, zIndex: 9000,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  };
  const box = {
    background: theme.toolbar?.background || '#fff',
    color: theme.toolbar?.text || '#1e293b',
    border: `1px solid ${theme.toolbar?.border || '#e2e8f0'}`,
    borderRadius: 10,
    padding: '24px 28px',
    minWidth: 380,
    maxWidth: 520,
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  };
  const optionBtn = (primary) => ({
    padding: '10px 16px',
    borderRadius: 6,
    cursor: isResolving ? 'not-allowed' : 'pointer',
    fontSize: 13,
    fontWeight: 600,
    opacity: isResolving ? 0.6 : 1,
    textAlign: 'left',
    width: '100%',
    ...(primary
      ? { background: '#3b82f6', border: 'none', color: '#fff' }
      : {
          background: 'transparent',
          border: `1px solid ${theme.toolbar?.buttonBorder || '#cbd5e1'}`,
          color: theme.toolbar?.buttonText || '#475569',
        }),
  });

  return (
    <div style={overlay} onClick={onClose}>
      <div style={box} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
          <span style={{ fontSize: 20, color: '#f59e0b', lineHeight: 1 }}>⚠</span>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>
            Конфликт синхронизации с GitLab
          </h3>
        </div>
        <p style={{ margin: '0 0 20px', fontSize: 13, opacity: 0.75 }}>
          Файл в GitLab был изменён с момента последней публикации.
          Выберите, какую версию оставить:
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
          <button onClick={onAcceptPlatform} disabled={isResolving} style={optionBtn(true)}>
            <div>Использовать версию платформы</div>
            <div style={{ fontSize: 11, fontWeight: 400, opacity: 0.85, marginTop: 2 }}>
              Перезаписать файл в GitLab текущей версией диаграммы
            </div>
          </button>
          <button onClick={onAcceptGitlab} disabled={isResolving} style={optionBtn(false)}>
            <div>Принять версию GitLab</div>
            <div style={{ fontSize: 11, fontWeight: 400, opacity: 0.85, marginTop: 2 }}>
              Загрузить DSL из GitLab в панель кода — затем нажмите «Применить» для отображения
            </div>
          </button>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            disabled={isResolving}
            style={{
              padding: '7px 18px', borderRadius: 6,
              cursor: isResolving ? 'not-allowed' : 'pointer',
              background: 'transparent',
              border: `1px solid ${theme.toolbar?.buttonBorder || '#cbd5e1'}`,
              color: theme.toolbar?.buttonText || '#475569',
              fontSize: 13, opacity: isResolving ? 0.6 : 1,
            }}
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiagramConflictModal;
